import { render, staticRenderFns } from "./SwapIcon.vue?vue&type=template&id=c24ecbe6"
import script from "./SwapIcon.vue?vue&type=script&lang=js"
export * from "./SwapIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports